// ── SmartTraQ Supabase Client ──
// Single shared instance — imported by db.js and App.jsx
import { createClient } from '@supabase/supabase-js';

let supabase = null;
try {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (url && key && url.includes('supabase.co')) {
    supabase = createClient(url, key, {
      auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true }
    });
  }
} catch (e) { console.warn('Supabase init skipped:', e.message); }

export default supabase;
